(() => {
  const strings = window.theme && window.theme.tabAttentionStrings;
  if (!strings) return;
  const delay = Number.parseInt(strings.messageDelay, 10) * 1000;
  if (!Number.isFinite(delay) || delay <= 0 || !strings.firstMessage) return;
  let originalTitle = document.title;
  let timer = null;
  let away = false;

  const restore = () => {
    if (document.hidden) return;
    clearTimeout(timer);
    timer = null;
    if (away) document.title = originalTitle;
    away = false;
  };

  const start = () => {
    if (away) return;
    originalTitle = document.title;
    away = true;
    document.title = strings.firstMessage;
    timer = setTimeout(() => {
      if (away && strings.nextMessage) document.title = strings.nextMessage;
    }, delay);
  };

  window.addEventListener('blur', start);
  window.addEventListener('focus', restore);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) start();
    else restore();
  });
  if (document.hidden) start();
})();
